export default __webpack_public_path__ + "static/media/FTP.8fde09ac.jpg";